// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__clWnl {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow-y: hidden; }

.styles_back__0XSyf {
  z-index: 1;
  padding: 1.5rem; }

.styles_forward__wnD8s {
  padding: 1.5rem;
  z-index: 1; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Screen/styles.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,UAAU;EACV,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,UAAU,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/mixins.scss\";\n\n.container {\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  overflow-y: hidden;\n}\n\n.back {\n  z-index: 1;\n  padding: 1.5rem;\n}\n\n.forward {\n  padding: 1.5rem;\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__clWnl`,
	"back": `styles_back__0XSyf`,
	"forward": `styles_forward__wnD8s`
};
export default ___CSS_LOADER_EXPORT___;
